




















import { Component, Mixins } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import { SurchargeStore } from "@/mixins/surcharge";

const STORAGE_KEY = "surcharge_banner_dismissed";

@Component
export default class SurchargeBanner extends Mixins(SurchargeStore) {
  private dismissed = false;

  /** FUMBSD-761: rate and date come from the API (GET /prices/surcharge) */
  get surchargeValue(): string {
    return this.surcharge.label;
  }

  get surchargeDate(): string {
    return this.surcharge.effective_date || "";
  }

  created() {
    this.dismissed = sessionStorage.getItem(STORAGE_KEY) === "true";
  }

  get visible(): boolean {
    return !this.dismissed && !!this.surchargeValue && !!this.surchargeDate;
  }

  dismiss(): void {
    this.dismissed = true;
    sessionStorage.setItem(STORAGE_KEY, "true");
    EventBus.$emit("surchargeBannerDismissed");
  }
}
